export enum RatingType {
  numeric = 'numeric',
  descriptive = 'descriptive',
  stars = 'stars'
}
